export const TRANSLATION_KEYS = {
    Heading: "ticketPage.heading",
    SecondaryHeading: "ticketPage.secondaryHeading",
    TicketPivotHeading: "ticketPage.ticketsPivot.heading",
    PersonalTicketPivotHeading: "ticketPage.ticketsPivot.headingPersonal"
};